<template>
  <svg
    width="447"
    height="150"
    viewBox="0 0 447 150"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M74.5128 146.925V117.091H3.12404L0.140625 92.7978L67.9067 0.738281H106.052V90.6668H125.444V117.091H106.052V146.925H74.5128ZM33.1713 90.6668H74.5128V33.982L33.1713 90.6668Z"
      fill="#0A45E7"
    />
    <path
      d="M155.372 0.738281H305.853C311.393 0.738281 315.888 5.23332 315.888 10.7729V146.924H145.344V10.7729C145.344 5.23332 149.839 0.738281 155.378 0.738281H155.372Z"
      fill="#D9E3F9"
    />
    <path d="M304.715 11.9473H156.516V146.724H304.715V11.9473Z" fill="white" />
    <path
      d="M304.689 11.5801H156.539V51.2988H304.689V11.5801Z"
      fill="#A9BFED"
    />
    <path d="M304.689 37.6074H156.539V39.3731H304.689V37.6074Z" fill="white" />
    <path d="M304.689 23.916H156.539V25.6817H304.689V23.916Z" fill="white" />
    <path
      d="M133.445 146.924H327.789"
      stroke="#B0C9E9"
      stroke-width="6"
      stroke-miterlimit="10"
    />
    <mask
      id="mask0_17185_207491"
      style="mask-type: alpha"
      maskUnits="userSpaceOnUse"
      x="156"
      y="51"
      width="149"
      height="96"
    >
      <path
        d="M304.715 51.2988H156.516V146.724H304.715V51.2988Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_17185_207491)">
      <path
        d="M230.512 143.926C193.983 143.926 168.352 114.259 168.352 72.078C168.352 30.0993 193.983 0.431641 230.512 0.431641C267.042 0.431641 292.875 30.0993 292.875 72.078C292.875 114.259 267.042 143.926 230.512 143.926ZM230.512 116.882C249.282 116.882 262.198 98.1129 262.198 72.078C262.198 46.0432 249.282 27.4756 230.512 27.4756C211.945 27.4756 198.827 46.0432 198.827 72.078C198.827 98.1129 211.945 116.882 230.512 116.882Z"
        fill="#0A45E7"
      />
    </g>
    <path
      d="M392.457 146.926C366.998 146.926 347.698 136.865 335.789 123.109L353.652 102.987C363.507 113.664 376.853 119.618 391.02 119.618C406.624 119.618 415.658 112.432 415.658 102.371C415.658 91.4895 407.24 85.9459 388.146 86.1512H371.925V60.2809L388.146 60.4863C403.545 60.4863 412.784 54.7373 412.784 44.6767C412.784 34.4107 403.134 27.8405 389.172 27.8405C375.826 27.8405 365.355 34.4107 355.91 44.266L338.458 25.7873C350.161 11.6202 366.998 0.738281 392.047 0.738281C423.871 0.738281 443.787 16.9585 443.787 39.3384C443.787 55.5586 432.7 67.2618 417.301 71.7788C432.7 75.2693 446.867 86.1512 446.867 104.835C446.867 129.268 425.308 146.926 392.457 146.926Z"
      fill="#0A45E7"
    />
  </svg>
</template>
